import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './CardLink.css';

const propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const defaultProps = {
  className: undefined,
  tag: 'a',
};

const CardLink = ({ className, tag: Tag, ...other }) => {
  const classes = classNames(className, 'apollo-card-link');
  return <Tag {...other} className={classes} />;
};

CardLink.propTypes = propTypes;
CardLink.defaultProps = defaultProps;

export default CardLink;
